import { financialProfileContentPageNav } from "../financial-profile/routes";
import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { QuickWinsContainer } from "./pages/quick-wins-container.tsx/quick-wins-container";

const quickWinsContentPath = "/quick-wins";
const quickWinsCompletedContentPath = "/quick-wins/Completed";

const quickWinsContentPageNav = buildBreadcrumbNavigationConfig(
  "Quick Wins",
  quickWinsContentPath
);

export const routes = [
  {
    path: quickWinsContentPath,
    Component: QuickWinsContainer,
    navigation: [financialProfileContentPageNav, quickWinsContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: quickWinsCompletedContentPath,
    Component: QuickWinsContainer,
    navigation: [financialProfileContentPageNav, quickWinsContentPageNav],
    exact: true,
    isPrivate: true,
  },
];
